import { useProductPageContext } from "shared/product/ProductPageContext/useProductPageContext";
import { ProductSectionData } from "shared/product/ProductSection/product-section.helper";
import { useI18n } from "utils/with-i18n.utils";

import { AdvantagesBanner } from "./AdvantagesBanner";
import { AdvantagesCard } from "./AdvantagesCard";

type AdvantagesSectionProps = {
  productData: ProductSectionData;
};

export const AdvantagesSection = ({ productData }: AdvantagesSectionProps) => {
  const i18n = useI18n();
  const { currentVariant } = useProductPageContext();

  if (!productData.productDetail) {
    return null;
  }

  return (
    <section className="border-t-[1px] border-gray">
      <div className="flex flex-col gap-6 py-[60px] px-4  mx-auto max-w-1440 md:gap-[60px] md:py-[96px] md:px-24">
        <h2 className="m-auto w-2/3 text-3xl font-medium text-center lg:text-6xl lg:leading-[71px]">
          {i18n.t("product.seo.advantages.title", {
            modelName: productData.family.modelName,
          })}
        </h2>
        {!Boolean(currentVariant?.mustBePurchased) && (
          <AdvantagesBanner
            modelName={productData.family.modelName ?? ""}
            brand={productData.family.brand ?? ""}
            image={currentVariant?.combinedPicture ?? undefined}
          />
        )}
        <div className="flex flex-col gap-6 justify-center lg:flex-row">
          {productData.productDetail.advantages.map((advantage) => {
            return (
              <AdvantagesCard
                icon={advantage.icon}
                title={advantage.title}
                text={advantage.content}
                key={advantage.title}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};
